import dayjs from 'dayjs';

export const useCancelInfo = ({ supervision }) => {
  const { decline, interrupt } = supervision || {};
  const cancelInfo = [
    {
      label: 'supervisions.form.interrupt.reason',
      span: 1,
      content: decline?.reason || '-'
    },
    {
      label: 'supervisions.form.interrupt.comment',
      span: 1,
      content: decline?.comment || '-'
    }
  ];

  const interruptInfo = [
    {
      label: 'supervisions.form.interrupt.reason',
      span: 1,
      content: interrupt?.reason || '-'
    },
    {
      label: 'supervisions.form.interrupt.comment',
      span: 1,
      content: interrupt?.comment || '-'
    },
    {
      label: 'supervisions.form.interrupt.application_date',
      span: 1,
      content:
        (interrupt?.application_date &&
          dayjs(interrupt.application_date).format('DD/MM/YYYY')) ||
        '-'
    },
    {
      label: 'supervisions.form.interrupt.duplicate_supervision',
      span: 1,
      content: (interrupt?.duplicate_supervision ? 'Oui' : 'Non') || '-'
    },
    {
      label: 'supervisions.form.interrupt.remaining_amount',
      span: 1,
      content:
        (interrupt?.remaining_amount && `${interrupt.remaining_amount} €`) ||
        '-'
    },
    {
      label: 'supervisions.form.interrupt.duplicate_supervision_reference',
      span: 1,
      content: interrupt?.duplicate_supervision_reference || '-'
    }
  ];

  return { cancelInfo, interruptInfo };
};
